import { AssignmentType } from '../type';

export type VoucherItem = {
  id: number;
  voucherCount: number;
  teacherId: string;
  name: string;
  type: AssignmentType;
  productId?: string | null;
};

export type VoucherHistoryCategory = '사용' | '적립';

export enum TxType {
  ADMIN_DEDUCTION = 'ADMIN_DEDUCTION',
  ADMIN_RECHARGE = 'ADMIN_RECHARGE',
  MATERIAL_PURCHASE = 'MATERIAL_PURCHASE',
  COURSE_PURCHASE = 'COURSE_PURCHASE',
  TODO_ASSIGNMENT = 'TODO_ASSIGNMENT',
  VOUCHER_PURCHASE = 'VOUCHER_PURCHASE',
  MATERIAL_REFUND = 'MATERIAL_REFUND',
  COURSE_REFUND = 'COURSE_REFUND',
  VOUCHER_REFUND = 'VOUCHER_REFUND',
  CANCEL_TODO_ASSIGNMENT = 'CANCEL_TODO_ASSIGNMENT',
  EXCHANGE = 'EXCHANGE',
}

export const TX_TYPE_LABEL_MAP: Partial<Record<TxType, string>> = {
  ADMIN_DEDUCTION: '관리자 차감',
  ADMIN_RECHARGE: '관리자 적립',
  MATERIAL_PURCHASE: '교재 구매',
  COURSE_PURCHASE: '코스 구매',
  TODO_ASSIGNMENT: '과제 배정(과제 내주기)',
  VOUCHER_PURCHASE: '이용권 구매',
  MATERIAL_REFUND: '교재 환불',
  COURSE_REFUND: '코스 환불',
  VOUCHER_REFUND: '이용권 환불',
  CANCEL_TODO_ASSIGNMENT: '과제 배정 취소',
  EXCHANGE: '교환',
};

export type VoucherHistoryItem = {
  id: number;
  date: string;
  category: VoucherHistoryCategory;
  amount: number;
  orderId?: string;
  todoInfo?: string;
  txType: TxType;
  txTypeLabel: string;
  assignedTodoTxId?: number;
};

export type VoucherHistory = {
  remaining: number;
  totalCharged: number;
  totalUsed: number;
  result: VoucherHistoryItem[];
};

export type VoucherProductItem = {
  voucherType: AssignmentType;
  productId: string;
};

export type VoucherHistoryInfo = {
  assignedAt: string;
  todoInfo: string;
  total: number;
  canceledCount: number;
};

export type VoucherHistoryStudentItem = {
  id: number;
  name: string;
  uid: string;
  classGroupName: string;
  isCanceled: boolean;
};
